export default "__VITE_ASSET__1202f817__"